<div class="employee-login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-icon mat-card-avatar class="employee-icon">business</mat-icon>
      <mat-card-title>Employee Sign In</mat-card-title>
      <mat-card-subtitle>Sign in with your Microsoft work account</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div class="login-content" *ngIf="!isAuthenticated">
        <div class="login-description">
          <mat-icon class="info-icon">info</mat-icon>
          <p>Use your organizational Microsoft account to access employee features and administrative tools.</p>
        </div>

        <div class="login-buttons">
          <button
            mat-flat-button
            color="primary"
            (click)="loginWithMicrosoft()"
            [disabled]="isLoading"
            class="microsoft-login-btn">
            <mat-icon *ngIf="!isLoading">account_circle</mat-icon>
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
            <span *ngIf="!isLoading">Sign in with Microsoft</span>
            <span *ngIf="isLoading">Signing in...</span>
          </button>

          <mat-divider></mat-divider>

          <button
            mat-stroked-button
            (click)="loginWithRedirect()"
            [disabled]="isLoading"
            class="redirect-login-btn">
            <mat-icon>open_in_new</mat-icon>
            Sign in with Redirect
          </button>
        </div>

        <div class="features-info">
          <h4>Employee Features:</h4>
          <ul>
            <li><mat-icon>security</mat-icon> Enhanced security with Multi-Factor Authentication</li>
            <li><mat-icon>admin_panel_settings</mat-icon> Access to administrative functions</li>
            <li><mat-icon>analytics</mat-icon> Advanced reporting and analytics</li>
            <li><mat-icon>group</mat-icon> Customer management tools</li>
          </ul>
        </div>
      </div>

      <div class="authenticated-content" *ngIf="isAuthenticated">
        <mat-icon color="primary" class="success-icon">check_circle</mat-icon>
        <h3>Welcome back!</h3>
        <p>You are already signed in. Redirecting to your dashboard...</p>
      </div>
    </mat-card-content>

    <mat-card-actions>
      <button mat-button (click)="goBack()" [disabled]="isLoading">
        <mat-icon>arrow_back</mat-icon>
        Back to Login Options
      </button>
    </mat-card-actions>
  </mat-card>
</div>
